export default __webpack_public_path__ + "static/media/thumbnail.b562b947.png";